import { z } from 'zod';

/**
 * Schema for downgrading subscription
 */
export const downgradeSubscriptionSchema = z.object({
  targetTier: z.enum(['TINKERER', 'HOBBYIST', 'BUSINESS']),
  reason: z.string().optional(),
});

export type DowngradeSubscriptionInput = z.infer<typeof downgradeSubscriptionSchema>;

/**
 * Schema for canceling subscription (downgrade to free)
 */
export const cancelSubscriptionSchema = z.object({
  reason: z.string().optional(),
});

export type CancelSubscriptionInput = z.infer<typeof cancelSubscriptionSchema>;
